import { render } from "./OnDutyTable.vue?vue&type=template&id=080e211e&ts=true"
import script from "./OnDutyTable.vue?vue&type=script&lang=ts"
export * from "./OnDutyTable.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__